import ExaminationQuestionSummaryList from './ExaminationQuestionSummaryList';

export default ExaminationQuestionSummaryList;
